import moment, { MomentInput } from 'moment';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeJourneyParam } from '@store/yourJourney/actions';

export function useSyncSpaDateToRedux(
  formDate: string | undefined,
  reduxSpaDate: MomentInput | undefined
) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!formDate) return;
    const reduxDateString = reduxSpaDate ? moment(reduxSpaDate).format('YYYY-MM-DD') : '';
    if (formDate !== reduxDateString) {
      dispatch(changeJourneyParam('spaDate', formDate) as any);
    }
  }, [formDate, reduxSpaDate, dispatch]);
}
